import * as React from "react";
// actions
import { getDiscoverInterestChart } from "@vingle/wtf-sdk/actions/discover";
// components
import NewlyTrending from "app/discover/components/newlyTrending";
import { useCancelToken } from "@vingle/wtf-sdk/helpers/hook";
import { useStoreState, useActions } from "app/store";

interface IHookProps extends ReturnType<typeof useProps> {}
interface IHookHandlers extends ReturnType<typeof useHandlers> {}

function useProps() {
  const actions = useActions({
    dispatchGetDiscoverInterestChart: getDiscoverInterestChart,
  });
  const states = useStoreState(state => ({
    interestCharts: state.discover.interestCharts,
  }));
  const cancelToken = useCancelToken();
  return {
    ...actions,
    ...states,
    cancelToken,
  };
}

function useHandlers(props: IHookProps) {
  const { cancelToken, dispatchGetDiscoverInterestChart } = props;
  const handleFetchData = React.useCallback(() => {
    dispatchGetDiscoverInterestChart({
      cancelToken: cancelToken.current.token,
    });
  }, []);
  return {
    handleFetchData,
  };
}

function useEffects(_props: IHookProps, handlers: IHookHandlers) {
  const { handleFetchData } = handlers;
  React.useEffect(() => {
    handleFetchData();
  }, []);
}

function InterestChart() {
  const hookProps = useProps();
  const hookHandlers = useHandlers(hookProps);
  useEffects(hookProps, hookHandlers);
  const { interestCharts } = hookProps;
  return (
    <NewlyTrending
      isLoading={!interestCharts.length}
      interestCharts={interestCharts}
    />
  );
}

export default React.memo(InterestChart);
